<p-table #dt (sortFunction)="customSort($event)" [customSort]="true" [paginator]="true" [rows]="20" [columns]="cols"
    [value]="items" [scrollable]="true" [style]="{'width':'100%'}" id="tabla_simple_cabecera"
    styleClass="p-datatable-gridlines">

    <ng-template pTemplate="caption">
        <div class="header-caption">
            <div class="flex items-center bg-white px-1 gap-5 rounded-md">
                <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                <input type="text" pInputText size="50" placeholder="Buscar..." [(ngModel)]="buscador"
                    (input)="buscadorEspecial($event.target.value)" style="width: 100% !important; margin: 0;">
            </div>

            <p-checkbox *ngIf="filterActive" name="active" binary="true" label="Activo" [(ngModel)]="isActive"
                inputId="activeInput" (click)="onFilter()"></p-checkbox>

            <div class="listartodos" *ngIf="!listarTodos">
                <p-checkbox name="groupname" value="val1" [(ngModel)]="selectedOpciones" class="listarTodos"
                    (click)="listarCampos()" label="Mostrar todos"></p-checkbox>
            </div>
            <div class="informes" *ngIf="!mostrarInformes">
                <button pButton type="button" label="Informes" class="p-button-info" (click)="consultar(dt)"></button>
            </div>
            <div *ngIf="showExportCsv">
                <button class="mx-2 btn btn-success" (click)="exportCsv()" style="padding: 5px; font-size: .8rem;">
                    <i class="fa fa-download"></i>
                    Exportar a CSV
                </button>
            </div>
            <ng-template *ngIf="header" ngFor let-col [ngForOf]="[cols]" let-i="index" [ngForTemplate]="header">
            </ng-template>
            <div class="nuevo" *ngIf="checkRoleRead() || showAdd">
                <button pButton type="button" label="Añadir" class="mx-2 btn btn-success" (click)="nuevo()"></button>
            </div>
        </div>

    </ng-template>

    <!-- TODO ? Saber que hace este apartado  -->
    <!-- <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
            <col *ngFor="let col of columns"
                [ngStyle]="{'width' : col.field === 'opciones' ? '110px' : col.width? col.width: '250px'}">
        </colgroup>
    </ng-template> -->
    <!-- -------- -->

    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of cols" [pSortableColumn]="col.field">

                <div *ngIf="col.field != 'verificacion'">
                    {{col.header}}

                    <div *ngIf="col.tipo=='texto'" style="overflow-wrap: break-word ">
                        <input type="text" pInputText name="filtro-text" id="filtro-text" placeholder="buscador"
                            appendTo="body" #texto (ngModelChange)="filtartTexto($event, dt, col.field)"
                            [(ngModel)]="text2" style="min-width: 90%; text-align: center;">
                    </div>

                    <div *ngIf="col.tipo=='fecha'" style="overflow-wrap: break-word ">
                        <p-calendar appendTo="body" #fecha (ngModelChange)="filtrarFecha($event, dt, col.field)"
                            [(ngModel)]="date2" [locale]="es" dateFormat="dd/mm/yy">

                        </p-calendar>

                    </div>
                    <!-- Icono que hace cambia el orden de la tabla si desemos eliminar este icono en una columna debemos añadir su field a la condicion -->
                    <p-sortIcon *ngIf="col.field != 'opciones' && col.field != 'proveedor_abv' " [field]="col.field"
                        ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </div>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr #rowTable>
            <td *ngFor="let col of columns;" [ngClass]="{'sin_etiqueta': comprobarDiscriminador(rowData) == true}">
                <div [ngSwitch]="col.field">
                    <div *ngSwitchCase="'opciones'">

                        <div style="margin-left:0">
                            <app-grupo-botones [database]="database" [id]="rowData.id" [data]="rowData"
                                [showDuplicate]="showDuplicate" [showInfo]="showInfo" (infoChild)="info($event)"
                                (editChild)="update($event, rowIndex)" (deleteChild)="delete($event)"
                                (duplicateChild)="duplicate($event)">
                            </app-grupo-botones>

                        </div>
                    </div>
                    <div *ngSwitchCase="'devolucion'">

                        <div style="display: flex;justify-content: space-around" *ngIf="rowData[col.field]=='1' ">
                            <p>OK</p>
                            <button *ngIf="checkRevisionTirita()" pButton type="button" icon="pi pi-refresh"
                                class="p-button-info" (click)="changeValue(rowData,rowIndex);"></button>
                        </div>
                        <div style="display: flex;justify-content: space-around" *ngIf="rowData[col.field]!='1'">
                            <p>NOK</p>
                            <button *ngIf="checkRevisionTirita()" pButton type="button" icon="pi pi-refresh"
                                class="p-button-danger" (click)="changeValue(rowData,rowIndex);"></button>
                        </div>


                    </div>
                    <div *ngSwitchCase="'revision'">

                        <div *ngIf="col.field == 'revision'">
                            <div *ngIf="checkRole()">

                                <app-validacion-boton [database]="database" [id]="rowData.id" [data]="rowData"
                                    (listarChild)="iniciar()">
                                </app-validacion-boton>
                            </div>
                        </div>
                    </div>
                    <div *ngSwitchCase="'archivo'">
                        <a *ngIf="viewDocument(rowData.archivo)" target="_blank" [href]="viewDocument(rowData.archivo)"
                            alt='adjunto'>
                            <img [src]="imageFile" class="image_firma" style="width:20px ;height: 20px; margin: 0;">
                            <div *ngIf="!viewDocument(rowData.archivo)">
                                X
                            </div>
                        </a>


                    </div>
                    <div *ngSwitchCase="'foto'">
                        <div *ngIf="rowData.archivo1 && rowData.archivo1.length > 0">
                            <img [src]="urlUploadArticulo+rowData.archivo1" class="image_firma"
                                style="width:30px ;height: 30px; margin: 0;">
                        </div>

                    </div>
                    <div *ngSwitchCase="'archivo1'">
                        <div *ngIf="rowData.archivo1 && rowData.archivo1.length > 0">
                            <img [src]="urlUploadPacks+rowData.archivo1" class="image_firma"
                                style="width:35px ;height: 35px; margin: 0;">
                        </div>

                    </div>



                    <div *ngSwitchCase="'adjunto'">
                        <a *ngIf="viewDocument(rowData.adjunto)" target="_blank" [href]="viewDocument(rowData.adjunto)"
                            alt='adjunto'>
                            <img [src]="imageFile" class="image_firma" style="width:20px ;height: 20px; margin: 0;">
                            <div *ngIf="!viewDocument(rowData.adjunto)">
                                X
                            </div>
                        </a>


                    </div>
                    <div *ngSwitchCase="'albaran'">

                        <a *ngIf="viewDocument(rowData.albaran)" target="_blank" [href]="viewDocument(rowData.albaran)"
                            alt='adjunto'>
                            <img [src]="imageFile" class="image_firma" style="width:20px ;height: 20px; margin: 0;">
                            <div *ngIf="!viewDocument(rowData.albaran)">
                                X
                            </div>
                        </a>


                    </div>
                    <div *ngSwitchCase="'certificado'">
                        <div *ngIf="certificado">
                            {{rowData[col.field]}}
                        </div>
                        <div *ngIf="!certificado">
                            <a *ngIf="viewDocument(rowData.certificado)" target="_blank"
                                [href]="viewDocument(rowData.certificado)" alt='adjunto'>
                                <img [src]="imageFile" class="image_firma" style="width:20px ;height: 20px; margin: 0;">
                                <div *ngIf="!viewDocument(rowData.certificado)">
                                    X
                                </div>
                            </a>
                        </div>



                    </div>
                    <div *ngSwitchCase="'asistentes'">
                        <div *ngIf="col.tipo =='texto'">
                            {{rowData[col.field]}}
                        </div>
                        <div *ngIf="col.tipo !='texto'">
                            <a *ngIf="viewDocument(rowData.asistentes)" target="_blank"
                                [href]="viewDocument(rowData.asistentes)" alt='adjunto'>
                                <img [src]="imageFile" class="image_firma" style="width:20px ;height: 20px; margin: 0;">
                            </a>
                            <div *ngIf="!viewDocument(rowData.asistentes)">
                                X
                            </div>
                        </div>




                    </div>
                    <div *ngSwitchCase="'calidad'">

                        {{ comprobarCalidad(rowData) }}

                    </div>
                    <div *ngSwitchCase="'observaciones'">
                        <div [innerHtml]="rowData[col.field]  | shortDescription">

                        </div>
                        <!--   {{ rowData[col.field] }} -->

                    </div>
                    <div *ngSwitchCase="'nuevaDiferencia'">

                        {{ comprobarNuevaDiferencia(rowData[col.field]) }}

                    </div>
                    <div *ngSwitchCase="'pesos'">
                        <div class="pesos">
                            {{ rowData[col.field] }}
                        </div>


                    </div>
                    <div *ngSwitchDefault>
                        <div class="pesos">
                            {{comprobarFilaValor(col.field,rowData[col.field])}}
                        </div>
                    </div>
                </div>


            </td>
        </tr>
    </ng-template>


</p-table>

<a href="#" id="csvLink" style="visibility: hidden; position: fixed;"></a>